const serverCfg = {
    server: "",
    cors: "cors",
}

export default serverCfg;